import axios from 'axios';
import apiUrl from '../../../constants'

export default new class {
	async getServicesDetails(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getServicesDetails',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getContractTermsCondition(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getContractTermsCondition',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async changeStatus(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'ChangeStatus',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getContractListing(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getContractListing',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getDetailsTarrifCard(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/gettariffcarddetails',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async gettermconditionListing(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getTermsCondition',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async addtermconditionListing(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/addTermsCondition',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async updatetermconditionListing(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/updateTermsCondition',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getServiceAreaListing(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getservicearealist',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getStateList() {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getstatelist'
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getCityList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getcitylist',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getZoneDetails(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getzonelist',
				'data': input
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getZoneDetailsById(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getzonedetails',
				'data': input
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getRegionList() {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getregionlist'
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async saveZoneDetails(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/savezonedetails',
				'data': input
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async createServiceArea(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/saveservicearea ',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getZoneList(input) {
		this.input = {}
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getallzones ',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getServiceAreaTemplateList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getallserviceareatemplates ',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getServiceAreaTemplateMapping(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getserviceareatemplatemapping ',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getServiceLevelListing(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getservicelevellist ',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getServiceLevelDropdown(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/GetServiceLevelDropdown ',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getServiceLevelDetail(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getServiceLevelDetail',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getServiceLevelCount(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/serviceleveldatacount',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async uploadSalesTAT (input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargomaster/uploadsalestat',
        'data': input,
				'timeout': 60 * 10 * 1000
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
	async validateSalesTAT (input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargomaster/validatesalestat',
        'data': input,
				'timeout': 60 * 10 * 1000
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
	async getInvalidSalesTATListing (input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargomaster/getinvalidsalestatlisting',
        'data': input
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
	async deletePreviousUploadSalesTAT (input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/deletepreviousuploadsalestat',
				'data': input
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getInvalidSalesTATForDownload (input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getinvalidsalestatfordownload',
				'data': input
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async saveServiceLevelTemplate(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/saveservicelevel ',
				'data': input,
				'timeout': 60 * 10 * 1000
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getSlabListing(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/slablist ',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async saveSlab(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/saveslab ',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getCitiesByStateId(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getcitylist ',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getCitiesByIds(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getcitydetailsbyids ',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getPincodeByCityId(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getpincodesbycity',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getAllSlab(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getallslabs',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getSlabDetails(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getslabdetails',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getOdaChargeList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getodachargeslist',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async saveOdaCharge(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/saveodacharges',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getOdaDetail(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getodadetail',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async updateZoneDetails(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/updatezonedetails',
				'data': input
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getAllCity(input) {
		try {
			let result = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'cargomaster/getallcity',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getTariffCardListing(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/gettariffcardlist',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getTariffCardListingForDropDown(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/gettariffcardlistfordropdown',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async deletePreviousUploadRateTAT (input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/deletepreviousuploadratetat',
				'data': input
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async uploadRateTAT (input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/uploadratetat',
				'data': input,
				'timeout': 60 * 10 * 1000
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getInvalidRateTATListing (input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getinvalidratetatlisting',
				'data': input
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getInvalidRateTATForDownload (input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getinvalidratetatfordownload',
				'data': input
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async saveTariffCard(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/savetariffcard',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getRateTemplateListing(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/ratetemplatemasterlist',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getRateTemplateMasterListDropdown(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/ratetemplatemasterlistDropdown',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async saveRateTemplateMaster(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/saveratetemplatemaster',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async rateTemplateMasterDetails(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/ratetemplatemasterdetails',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async saveBaseRate(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/ratetemplate/savebaserate',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async saveInsuranceRate(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/ratetemplate/saveinsurancerate',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getBaseCityList(input) {
		try {
			let result = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'cargomaster/getbasecitylist',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getBaseRateList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/ratetemplate/getBaseRateList',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getInsuranceRateList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/ratetemplate/getInsuranceRateList',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getOdaChargesList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getodachargeslist',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getOdaChargesListForDropDown(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getodachargeslistfordropdown',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async saveVehicleDelivery(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/savevehicledeliveryrate',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getVehicleDeliveryDetails(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getVehicleDeliveryRateList',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async saveOverWtCharge(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/saveoverweightcharge',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getOverWtChargeDetails(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getoverweightchargelist',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async saveOdaCharges(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/ratetemplate/saveOdaCharges',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async saveServicesForContract(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/SaveServicesForContractTemplate',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getOdaChargeListRateTemplate(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/ratetemplate/getOdaChargeList',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getTemplateListForDropDown(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/gettermsconditiondronpdown',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getTCTemplateDetail(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/gettermsconditiondetails',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async saveContractTCTemplate(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/savecontracttc',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async removeAnnexureContractData(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/deletecontractannexure',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getContractAnnexureListing(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getcontractannexure',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async createContractAnnexure(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/savecontractannexure',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async uploadDocment(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'awsutils/uploadDocment',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getApprovalHierarchyRole(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'approvalhierarchy/getapprovalhierarchyrole',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getContractListingForDropDown(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getcontractlistingfordropdown',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getContractDetial(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getcontractdetial',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}

    async saveContractMasterRate(input) {
        try {
            let result = await axios({
                method: 'POST',
                'url': apiUrl.api_url + 'cargomaster/contractmaster/savecontractmasterrate',
                'data': input,
            })
            return result;
        } catch (err) {
            throw new Error(err);
        }
    }
    async contractMasterRateDetails(input) {
        try {
            let result = await axios({
                method: 'POST',
                'url': apiUrl.api_url + 'cargomaster/contractmaster/contractmasterratedetails',
                'data': input,
            })
            return result;
        } catch (err) {
            throw new Error(err);
        }
    }
    async saveContractMasterInsuranceRate(input) {
        try {
            let result = await axios({
                method: 'POST',
                'url': apiUrl.api_url + 'cargomaster/contractmaster/savecontractmasterinsurancerate',
                'data': input,
            })
            return result;
        } catch (err) {
            throw new Error(err);
        }
    }
    async getContractInsuranceRateList(input) {
        try {
            let result = await axios({
                method: 'POST',
                'url': apiUrl.api_url + 'cargomaster/contractmaster/getcontractmasterinsuranceratelist',
                'data': input,
            })
            return result;
        } catch (err) {
            throw new Error(err);
        }
    }
    async saveContractMasterBaseRate(input) {
        try {
            let result = await axios({
                method: 'POST',
                'url': apiUrl.api_url + 'cargomaster/contractmaster/savecontractmasterbaserate',
                'data': input,
            })
            return result;
        } catch (err) {
            throw new Error(err);
        }
    }
    //need to correct spelling
    async getContractMasterBaseRatelist(input) {
        try {
            let result = await axios({
                method: 'POST',
                'url': apiUrl.api_url + 'cargomaster/contractmaster/getcontractmasterbaseratelist',
                'data': input,
            })
            return result;
        } catch (err) {
            throw new Error(err);
        }
    }
    async saveContractMasterVehicleDeliveryRate(input) {
        try {
            let result = await axios({
                method: 'POST',
                'url': apiUrl.api_url + 'cargomaster/contractmaster/savecontractmastervehicledeliveryrate',
                'data': input,
            })
            return result;
        } catch (err) {
            throw new Error(err);
        }
    }
    async getContractVehicleDeliveryRateList(input) {
        try {
            let result = await axios({
                method: 'POST',
                'url': apiUrl.api_url + 'cargomaster/contractmaster/getcontractmastervehicledeliveryratelist',
                'data': input,
            })
            return result;
        } catch (err) {
            throw new Error(err);
        }
    }
    async saveContractmasterOverWeightCharge(input) {
        try {
            let result = await axios({
                method: 'POST',
                'url': apiUrl.api_url + 'cargomaster/contractmaster/savecontractmasteroverweightcharge',
                'data': input,
            })
            return result;
        } catch (err) {
            throw new Error(err);
        }
    }
    async getContractMasterOverWeightChargeList(input) {
        try {
            let result = await axios({
                method: 'POST',
                'url': apiUrl.api_url + 'cargomaster/contractmaster/getcontractmasteroverweightchargelist',
                'data': input,
            })
            return result;
        } catch (err) {
            throw new Error(err);
        }
    }
    async getContractMasterOdaChargeList(input) {
        try {
            let result = await axios({
                method: 'POST',
                'url': apiUrl.api_url + 'cargomaster/contractmaster/getcontractmasterodachargelist',
                'data': input,
            })
            return result;
        } catch (err) {
            throw new Error(err);
        }
    }
    async saveContractMasterOdaCharges(input) {
        try {
            let result = await axios({
                method: 'POST',
                'url': apiUrl.api_url + 'cargomaster/contractmaster/savecontractmasterodacharges',
                'data': input,
            })
            return result;
        } catch (err) {
            throw new Error(err);
        }
	}
	async getContractMasterServicesDetails(input) {
        try {
            let result = await axios({
                method: 'POST',
                'url': apiUrl.api_url + 'cargomaster/getContractMasterServicesDetails',
                'data': input,
            })
            return result;
        } catch (err) {
            throw new Error(err);
        }
	}
	async getClientContractMasterServicesDetails(input) {
        try {
            let result = await axios({
                method: 'POST',
                'url': apiUrl.api_url + 'cargomaster/getClientContractMasterServicesDetails',
                'data': input,
            })
            return result;
        } catch (err) {
            throw new Error(err);
        }
	}
	async saveClientContractMasterRate(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/clientcontract/savecontractmasterrate',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async clientContractMasterRateDetails(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/clientcontract/contractmasterratedetails',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getClientContractInsuranceRateList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/clientcontract/getcontractmasterinsuranceratelist',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async saveClientContractMasterInsuranceRate(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/clientcontract/savecontractmasterinsurancerate',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getClientContractMasterBaseRateList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/clientcontract/getcontractmasterbaseratelist',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async saveClientContractBaseRate(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/clientcontract/savecontractmasterbaserate',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async saveClientContractBaseRate(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/clientcontract/savecontractmasterbaserate',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getClientContractMasterOdaChargeList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/clientcontract/getcontractmasterodachargelist',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async saveClientContractMasterOdaCharges(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/clientcontract/savecontractmasterodacharges',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getClientContractMasterOverWeightChargeList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/clientcontract/getcontractmasteroverweightchargelist',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async saveClientContractMasterOverWeightCharge(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/clientcontract/savecontractmasteroverweightcharge',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getClientContractMasterVehicleDeliveryRateList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/clientcontract/getcontractmastervehicledeliveryratelist',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async saveClientContractMasterVehicleDeliveryRate(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/clientcontract/savecontractmastervehicledeliveryrate',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async getRolesList() {
		try {
			let result = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'external/getroleslist'
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getUseRagainRolesID(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'external/getuseragainrolesid',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async createHerarchyRole(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'approvalhierarchy/createhierarchyrole',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async updateRole(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'approvalhierarchy/updateapprovalhierarchyrole',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getBoxTypeListing(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/boxtypelist ',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async saveBoxType(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/saveboxtype ',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getBoxTypeDetails(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getboxtypedetails ',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getAllBoxTypes(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getallboxtypes ',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getAllBoxStackingLevels(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getallboxstackinglevels ',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getAllBoxStrengths(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/getallboxstrengths ',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getActiveInactiveClientList() {
    try {
      let result = await axios({
        method: 'GET',
        'url': apiUrl.api_url + 'external/cargoclientkyc/getactiveinactiveclient',
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
	async GetHublist() {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargomaster/gethublist',
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
	async getTATPincodelist(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargomaster/gettatpincodelist',
		'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
	async getOpsTATlist() {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargomaster/getopstatlist',
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
	async validateClientContractTariff(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'clientcontract/validatetariffdata',
				'data': input,
				'timeout': 60 * 10 * 1000
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
  };
  async validateTariff(input) {
	try {
		let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargomaster/validatetariffdata',
			'data': input,
			'timeout': 60 * 10 * 1000
		})
		return result;
	} catch (err) {
		throw new Error(err);
	}
  };
  async getUploadedSlabDetails(input) {
	try {
		let result = await axios({
			method: 'POST',
			'url':  apiUrl.api_url + 'cargomaster/getuploadedslabdetails',
			'data': input,
		})
		return result;
	} catch (err) {
		throw new Error(err);
	}
  };
	async getBasicTariffData(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/gettariffcardbasicdetails',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getTariffDetailsForDownload(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/gettariffcarddetailsfordownload',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getTariffDetailsCount(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargomaster/gettariffcarddetailscount',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getBasicBaserate(input) {
	  try {
	    let result = await axios({
	      method: 'POST',
	      'url': apiUrl.api_url + 'cargomaster/ratetemplate/getBasicBaserate',
	      'data': input,
	    })
	    return result;
	  } catch (err) {
	    throw new Error(err);
	  }
	};
	async getBaserateForDownload(input) {
	  try {
	    let result = await axios({
	      method: 'POST',
	      'url': apiUrl.api_url + 'cargomaster/ratetemplate/getBaserateForDownload',
	      'data': input,
	    })
	    return result;
	  } catch (err) {
	    throw new Error(err);
	  }
	};
	async getContractBasicBaserate(input) {
	  try {
	    let result = await axios({
	      method: 'POST',
	      'url': apiUrl.api_url + 'cargomaster/contractmaster/getContractBasicBaserate',
	      'data': input,
	    })
	    return result;
	  } catch (err) {
	    throw new Error(err);
	  }
	};
	async getContractBaserateForDownload(input) {
	  try {
	    let result = await axios({
	      method: 'POST',
	      'url': apiUrl.api_url + 'cargomaster/contractmaster/getContractBaserateForDownload',
	      'data': input,
	    })
	    return result;
	  } catch (err) {
	    throw new Error(err);
	  }
	};
	async getClientContractBasicBaserate(input) {
	  try {
	    let result = await axios({
	      method: 'POST',
	      'url': apiUrl.api_url + 'cargomaster/clientcontract/getClientContractBasicBaserate',
	      'data': input,
	    })
	    return result;
	  } catch (err) {
	    throw new Error(err);
	  }
	};
	async getClientContractServiceSalesTAT(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'clientcontract/getClientContractServiceSalesTAT',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getClientContractBaserateForDownload(input) {
	  try {
	    let result = await axios({
	      method: 'POST',
	      'url': apiUrl.api_url + 'cargomaster/clientcontract/getClientContractBaserateForDownload',
	      'data': input,
	    })
	    return result;
	  } catch (err) {
	    throw new Error(err);
	  }
	};
	async getServicesDetailsforView(input) {
	  try {
	    let result = await axios({
	      method: 'POST',
	      'url': apiUrl.api_url + 'cargomaster/getServicesDetailsforView',
	      'data': input,
	    })
	    return result;
	  } catch (err) {
	    throw new Error(err);
	  }
	};
	async getContractMasterServicesDetailsforDownload(input) {
	  try {
	    let result = await axios({
	      method: 'POST',
	      'url': apiUrl.api_url + 'cargomaster/getContractMasterServicesDetailsforDownload',
	      'data': input,
	    })
	    return result;
	  } catch (err) {
	    throw new Error(err);
	  }
	};
	async getContractMasterServicesDetailsCount(input) {
	  try {
	    let result = await axios({
	      method: 'POST',
	      'url': apiUrl.api_url + 'cargomaster/getContractMasterServicesDetailsCount',
	      'data': input,
	    })
	    return result;
	  } catch (err) {
	    throw new Error(err);
	  }
	};
	async saveClientEBNExemption(input) {
	  try {
	    let result = await axios({
	      method: 'POST',
	      'url': apiUrl.api_url + 'config/saveclientebnexemption',
	      'data': input,
	    })
	    return result;
	  } catch (err) {
	    throw new Error(err);
	  }
	};
	async getClientEBNExemption(input) {
	  try {
	    let result = await axios({
	      method: 'POST',
	      'url': apiUrl.api_url + 'config/getclientebnexemption',
	      'data': input,
	    })
	    return result;
	  } catch (err) {
	    throw new Error(err);
	  }
	};
	async getPinCodeAllocationList(input) {
		try {
		  let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'pincodeallocations/pincodeallocationlist',
			'data': input,
		  })
		  return result;
		} catch (err) {
		  throw new Error(err);
		}
	  };
	  async getStateListByZone(input) {
		try {
		  let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargomaster/getstatelistbyzone',
			'data': input,
		  })
		  return result;
		} catch (err) {
		  throw new Error(err);
		}
	  };
	  async fetchZoneData(){
		try {
			let result = await axios({
			  method: 'POST',
			  'url': apiUrl.api_url + 'pincodeallocations/fetchzonelist',
			})
			return result;
		  } catch (err) {
			throw new Error(err);
		  }
	  };
	  async getOdaPincodeList(){
		try {
			let result = await axios({
			  method: 'POST',
			  'url': apiUrl.api_url + 'pincodeallocations/odapincodelist',
			})
			return result;
		  } catch (err) {
			throw new Error(err);
		  }
	  };
	  async getBaseRateCount(input) {
		try {
		  let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargomaster/ratetemplate/getBaseRateCount',
			'data': input,
		  })
		  return result;
		} catch (err) {
		  throw new Error(err);
		}
	  };
	  async getContractBaseRateCount(input) {
		try {
		  let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargomaster/contractmaster/getContractBaseRateCount',
			'data': input,
		  })
		  return result;
		} catch (err) {
		  throw new Error(err);
		}
	  };
	  async getClientContractBaserateCount(input) {
		try {
		  let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargomaster/clientcontract/getClientContractBaserateCount',
			'data': input,
		  })
		  return result;
		} catch (err) {
		  throw new Error(err);
		}
	  };
	  async uploadCSVFile(input) {
		try {
		  let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'airwallet/porttoportcsvupload',
			'data': input,
		  })
		  return result;
		} catch (err) {
		  throw new Error(err);
		}
	  };
	  async getAirlineRates(input) {
		try {
		  let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'airwallettemplate/getairlineratelistforcategory',
			'data': input,
		  })
		  return result;
		} catch (err) {
		  throw new Error(err);
		}
	  };
	  async createAirlineRate(input) {
		try {
		 let result = await axios({
		  method: 'POST',
		  'url': apiUrl.api_url + 'airwallettemplate/createairlinerate',
		  'data': input,
		})
		return result;
		} catch (err) {
		  throw new Error(err);
		}
	};
	  async GetCategoryListingAndVersionDetails(input) {
		try {
		 let result = await axios({
		  method: 'POST',
		  'url': apiUrl.api_url + 'airwallettemplate/getcategorylistingandversiondetails',
		  'data': input,
		})
		return result;
		} catch (err) {
		  throw new Error(err);
		}
	};
	async GetAirlineRatesDetails(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'airwallettemplate/getairlineratedata',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async DeleteAirrateEntry(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'airwallettemplate/deleteairlineratedata',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	  async GetActiveAirlinesForCategory(input) {
		try {
		 let result = await axios({
		  method: 'POST',
		  'url': apiUrl.api_url + 'airwallettemplate/getactiveairlinesforcategory',
		  'data': input,
		})
		return result;
		} catch (err) {
		  throw new Error(err);
		}
	};
	  async downloadAirlineRates(input) {
		try {
		 let result = await axios({
		  method: 'POST',
		  'url': apiUrl.api_url + 'airwallettemplate/downloadaircargocharges',
		  'data': input,
		})
		return result;
		} catch (err) {
		  throw new Error(err);
		}
	};
	  async UpdateAirlineMasterData(input) {
		try {
		 let result = await axios({
		  method: 'POST',
		  'url': apiUrl.api_url + 'airwallettemplate/upadteairlinemasterdata',
		  'data': input,
		})
		return result;
		} catch (err) {
		  throw new Error(err);
		}
	};
	async SaveUploadedAirlineRates(input) {
		try {
		 let result = await axios({
		  method: 'POST',
		  'url': apiUrl.api_url + 'airwallettemplate/saveuploadedairlinerates',
		  'data': input,
		})
		return result;
		} catch (err) {
		  throw new Error(err);
		}
	};
	async SaveCategoryTemplateForClient(input) {
		try {
		 let result = await axios({
		  method: 'POST',
		  'url': apiUrl.api_url + 'airwallettemplate/savecategorytemplateforclient',
		  'data': input,
		})
		return result;
		} catch (err) {
		  throw new Error(err);
		}
	};
	async changeCategotyStatus(input) {
		try {
		 let result = await axios({
		  method: 'POST',
		  'url': apiUrl.api_url + 'airwallettemplate/changeStatus',
		  'data': input,
		})
		return result;
		} catch (err) {
		  throw new Error(err);
		}
	};
	async checkAirlineDate(input) {
		try {
		 let result = await axios({
		  method: 'POST',
		  'url': apiUrl.api_url + 'airwallettemplate/checkairlineDate',
		  'data': input,
		})
		return result;
		} catch (err) {
		  throw new Error(err);
		}
	};
	  async validateSalesTAT18x18(input) {
		try {
		  let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargomaster/validateSalestat18x18',
			'data': input,
		  })
		  return result;
		} catch (err) {
		  throw new Error(err);
		}
	  };
	  async validateTariffRate18x18(input) {
		try {
		  let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargomaster/validatetariffrate18x18',
			'data': input,
		  })
		  return result;
		} catch (err) {
		  throw new Error(err);
		}
	  };
	async GetZoneToZoneDataFOrDownload(input) {
		try {
		  let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargomaster/getzonetozonedatafordownload',
			'data': input,
		  })
		  return result;
		} catch (err) {
		  throw new Error(err);
		}
	  };
	  async GetZoneNames(input) {
		try {
		  let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargomaster/getzonenames',
			'data': input,
		  })
		  return result;
		} catch (err) {
		  throw new Error(err);
		}
	  };
	  async removeExceptionalCities(input) {
		try {
		  let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargomaster/clientcontract/removeExceptionalCities',
			'data': input,
		  })
		  return result;
		} catch (err) {
		  throw new Error(err);
		}
	  };
	  async getLocationListDieselPrice(input) {
		try {
		 let result = await axios({
		  method: 'POST',
		  'url': apiUrl.api_url + 'cargomaster/getlocationlistdieselprice',
		  'data': input,
		})
		return result;
		} catch (err) {
		  throw new Error(err);
		}
	};
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/services/masterdata.service.js